import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NotificacionesPushService = /** @class */ (function () {
    function NotificacionesPushService(http) {
        this.http = http;
        this.VAPID_PUBLIC_KEY = 'BMqLlQRrfERhM2nlGAZiyc5SKalTzR_TXRhxa7Rp563Gi8eYCbOwhcUHJMki5u3bXYJYcwEU9-I3c7xkSiAihV8';
    }
    NotificacionesPushService.prototype.agregarSubscriptorPush = function (sub) {
        return this.http.post(environment.baseUrl + '/subscriptor-push/', sub);
    };
    NotificacionesPushService.prototype.borrarSubscriptorPush = function (sub) {
        var httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            body: sub
        };
        return this.http.delete(environment.baseUrl + '/subscriptor-push/', httpOptions);
    };
    NotificacionesPushService.ngInjectableDef = i0.defineInjectable({ factory: function NotificacionesPushService_Factory() { return new NotificacionesPushService(i0.inject(i1.HttpClient)); }, token: NotificacionesPushService, providedIn: "root" });
    return NotificacionesPushService;
}());
export { NotificacionesPushService };
